import React from 'react'
import { Check } from 'lucide-react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { buildViewToggleItems } from '../helpers/view-toggle-items'
import type { ViewToggleItem } from '../types/menu-items'
import type { MenubarViewToggles } from '../types/menubar-view-toggles'
import { MobileMenuSection } from './mobile-menu-section'
import { StyledCheckboxItem, StyledMenuItem, StyledSeparator } from './styled-menu-items'

type MobileViewSectionProps = {
  gridMode: 'off' | 'full' | 'half'
  onToggleFullPica?: (checked: boolean) => void
  onToggleHalfPica?: (checked: boolean) => void
  viewToggles: MenubarViewToggles
  openGuidesDialog: () => void
}

const renderToggle = (item: ViewToggleItem, index: number) => (
  <StyledCheckboxItem
    key={index}
    checked={item.checked}
    disabled={item.disabled}
    onClick={() => item.set(!item.checked)}
  >
    {item.label}
  </StyledCheckboxItem>
)

export const MobileViewSection: React.FC<MobileViewSectionProps> = ({
  gridMode,
  onToggleFullPica,
  onToggleHalfPica,
  viewToggles,
  openGuidesDialog,
}) => {
  const toggles = buildViewToggleItems(viewToggles)

  return (
    <MobileMenuSection value="view" label="View">
      {/* Show Grid submenu */}
      <Accordion
        type="single"
        collapsible
        className="w-full"
        onValueChange={(value) => {
          if (value === 'show-grid') {
            viewToggles.clearGrid()
          }
        }}
      >
        <AccordionItem value="show-grid" className="border-0">
          <AccordionTrigger className="py-1.5 pr-2 text-sm font-normal leading-[20px] hover:no-underline">
            <div className="relative flex items-center w-full">
              <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
                {(gridMode === 'full' || gridMode === 'half') && <Check className="h-4 w-4" />}
              </span>
              <span className="pl-8">Show Grid</span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="pb-0 pt-0 pl-8">
            <div className="flex flex-col gap-0">
              <StyledCheckboxItem
                checked={gridMode === 'full'}
                onClick={() => {
                  const newValue = gridMode !== 'full'

                  onToggleFullPica?.(newValue)
                }}
              >
                Full Pica
              </StyledCheckboxItem>
              <StyledCheckboxItem
                checked={gridMode === 'half'}
                onClick={() => {
                  const newValue = gridMode !== 'half'

                  onToggleHalfPica?.(newValue)
                }}
              >
                Half Pica
              </StyledCheckboxItem>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      {toggles.grid.map(renderToggle)}
      <StyledSeparator />
      {toggles.guides.map(renderToggle)}
      <StyledMenuItem onClick={openGuidesDialog}>Set Columns & Rows Guides</StyledMenuItem>
      <StyledSeparator />
      {toggles.overlays.map(renderToggle)}
    </MobileMenuSection>
  )
}
